export default "__VITE_PUBLIC_ASSET__62b0938f__"